import FadeSlide from '@/components/common/FadeSlide';
import { ClipboardContext } from '@/context/ClipboardContext';
import { useApplication } from '@/hooks/useApplication';
import { useSubroutine } from '@/hooks/useSubroutine';
import { copyNodesToClipboard } from '@/util/clipboard';
import { arraysAreEqual } from '@/util/equal';
import { Stack } from '@mui/material';
import { useState } from 'react';

export const ClipboardContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { application } = useApplication();
  const { selectedSubroutineId } = useSubroutine();
  const [copySuccessful, setCopySuccessful] = useState(false);
  const [selectedNodeIds, setSelectedNodeIds_] = useState<string[]>([]);
  const [copiedIds, setCopiedIds] = useState<number>(0);

  const handleCopy = (ids?: string[]) => {
    if (!selectedNodeIds.length && !ids?.length) return;

    const nodesToCopy = ids || selectedNodeIds;
    nodesToCopy &&
      copyNodesToClipboard(application, selectedSubroutineId, nodesToCopy).then((ids) => {
        setCopiedIds(ids);
        setCopySuccessful(true);
      });
  };

  const setSelectedNodeIds = (nodesToSelect: string[]) => {
    if (!arraysAreEqual(selectedNodeIds, nodesToSelect)) {
      setSelectedNodeIds_(nodesToSelect);
    }
  };

  return (
    <ClipboardContext.Provider
      value={{
        copySuccessful: copySuccessful,
        setCopySuccessful: setCopySuccessful,
        selectedNodeIds: selectedNodeIds,
        setSelectedNodeIds: setSelectedNodeIds,
        handleCopy: handleCopy,
        copiedIds: copiedIds
      }}
    >
      <>
        {children}
        {copySuccessful && (
          <Stack
            position='absolute'
            top={0}
            width='100%'
            height='100%'
            justifyContent='center'
            alignItems='center'
            sx={{ pointerEvents: 'none' }}
          >
            <FadeSlide
              message={`Copied ${copiedIds} node${copiedIds === 1 ? '' : 's'}!`}
              onDone={() => setCopySuccessful(false)}
            />
          </Stack>
        )}
      </>
    </ClipboardContext.Provider>
  );
};
